/**
 * Mark an m-section of an SDP with a=label (RFC 4574).
 *
 * The camera's video m-section is sent as a=label:camera, so the screen-share slot reserved for v2 can be told apart
 * from it by label rather than by position (spec §7.2). The browser has no API for this, so SipClient rewrites the
 * outgoing SDP through JsSIP's 'sdp' event.
 */

/**
 * Add a=label:<label> to the m-section with a=mid:<mid>, right after its a=mid line
 * @param sdp The session description
 * @param mid The mid of the m-section to label
 * @param label The label, e.g. 'camera'
 * @returns The SDP with the label added - unchanged if that section already has this label, or no section has that mid
 */
export function addLabelToMid(sdp: string, mid: string, label: string): string {
	const eol = sdp.includes('\r\n') ? '\r\n' : '\n'
	const lines = sdp.split(eol)
	const midLine = lines.indexOf(`a=mid:${mid}`)

	if (midLine === -1) { return sdp }

	const start = lines.slice(0, midLine).map(line => line.startsWith('m=')).lastIndexOf(true)

	// An a=mid in the session part, before any m= line, is not a media section
	if (start === -1) { return sdp }

	const next = lines.findIndex((line, index) => index > midLine && line.startsWith('m='))
	const section = lines.slice(start, next === -1 ? lines.length : next)
	const labelLine = `a=label:${label}`

	if (section.includes(labelLine)) { return sdp }

	lines.splice(midLine + 1, 0, labelLine)
	return lines.join(eol)
}
